import { eur, pct, pctInt, foodCostTone } from "@/lib/format";
import { t } from "@/i18n";

function Row({ label, value, tone = "", testId, big }) {
  return (
    <div className="flex items-baseline justify-between py-2">
      <span className="text-sm text-muted-foreground">{label}</span>
      <span className={`num ${big ? "text-xl" : "text-sm"} font-semibold ${tone}`} data-testid={testId}>{value}</span>
    </div>
  );
}

export default function CostBreakdown({ m, price, target, lines }) {
  const fcPctWidth = Math.min(100, m.foodCost * 2);
  const barColor = m.foodCost <= target ? "bg-emerald-500" : m.foodCost <= target + 5 ? "bg-amber-500" : "bg-rose-500";
  const targetPrice = target ? m.cost / (target / 100) : 0;
  const top = [...lines].filter((l) => l.cost > 0).sort((a, b) => b.cost - a.cost).slice(0, 5);

  return (
    <div className="rounded-2xl border bg-card p-5 lg:sticky lg:top-6" data-testid="recipe-cost-breakdown-card">
      <p className="eyebrow">{t("costBreakdown.rentabilite_du_plat")}</p>
      <div className="mt-3">
        <p className="text-xs text-muted-foreground">{t("common.cout_matiere")}</p>
        <p className={`num text-4xl font-bold tracking-tight ${foodCostTone(m.foodCost, target)}`} data-testid="breakdown-food-cost-pct">{pct(m.foodCost)}</p>
        <div className="relative mt-3 h-2 overflow-hidden rounded-full bg-muted">
          <div className={`h-full transition-all duration-500 ${barColor}`} style={{ width: `${fcPctWidth}%` }} />
          <div className="absolute top-0 h-full w-0.5 bg-foreground/60" style={{ left: `${target * 2}%` }} />
        </div>
        <p className="mt-1 text-[11px] text-muted-foreground">{t("costBreakdown.objectif")} {pctInt(target)}</p>
      </div>
      <div className="mt-4 divide-y border-t">
        <Row label={t("costBreakdown.cout_de_revient")} value={eur(m.cost)} testId="breakdown-recipe-cost" />
        <Row label={t("costBreakdown.prix_de_vente_ht")} value={eur(price)} testId="breakdown-selling-price" />
        <Row label={t("costBreakdown.marge_brute")} value={eur(m.margin)} testId="breakdown-gross-margin" big />
        <Row label={t("costBreakdown.marge_brute_2")} value={pct(m.marginPct)} testId="breakdown-gross-margin-pct" />
        <Row label={t("costBreakdown.profit_par_plat")} value={eur(m.margin)} tone={m.margin >= 0 ? "text-emerald-600 dark:text-emerald-400" : "text-rose-500"} testId="breakdown-profit-per-dish" />
      </div>
      {m.foodCost > target && price > 0 && (
        <div className="mt-4 rounded-lg border border-amber-500/30 bg-amber-500/10 p-3 text-xs" data-testid="breakdown-price-advice">
          {t("costBreakdown.pour_revenir_a")} {target} {t("costBreakdown.vendez_a")} <strong className="num">{eur(targetPrice)}</strong> (+{eur(targetPrice - price)}).
        </div>
      )}
      {top.length > 0 && (
        <div className="mt-5">
          <p className="eyebrow mb-2">{t("costBreakdown.postes_de_cout")}</p>
          {top.map((l, i) => (
            <div key={i} className="mb-2">
              <div className="flex justify-between text-xs"><span className="truncate">{l.name}</span><span className="num">{eur(l.cost)}</span></div>
              <div className="mt-1 h-1 overflow-hidden rounded-full bg-muted">
                <div className="h-full bg-[hsl(var(--ai))]" style={{ width: `${m.cost ? (l.cost / m.cost) * 100 : 0}%` }} />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
